import type { FC } from "react";

import styled from "styled-components";

import { formatDate } from "@similarweb/pro-logic-components";
import { ChartTooltip } from "@similarweb/ui-components";

import { computeYoY, formatVisits } from "../../../helpers";

import { COLUMN_DEFINITION_VISITS_OVERTIME } from "./columnDefinitions";
import type { VisitsOvertimeTooltipFormatterProps, TooltipPoint, TooltipRow } from "./types";

const TOOLTIP_WIDTH = 368;
const HEADER_FORMAT = "MMMM YYYY";

const processTooltipPoints = (points: TooltipPoint[]) => {
    return points.map(({ series, y: current, x }) => {
        const idx = series.data.findIndex((data) => data.x === x);
        const previous = series.data?.[idx - 1]?.y ?? null;
        const { label, isDecrease, unsigned } = computeYoY(current, previous);

        return {
            lob: {
                label: series.name,
                background: series.color,
            },
            visits: {
                value: formatVisits(current),
            },
            change: {
                value: label,
                isDecrease,
                unsigned,
            },
        };
    });
};

const TooltipWrapper = styled.div`
    padding: 16px;
`;
const VisitsOvertimeChartTooltip: FC<VisitsOvertimeTooltipFormatterProps> = ({ record }) => {
    const { points } = record;

    if (!points.length) {
        return null;
    }

    const title = formatDate(points[0].x, null, HEADER_FORMAT);
    const rows = processTooltipPoints(points);

    return (
        <TooltipWrapper>
            <ChartTooltip<TooltipRow>
                width={TOOLTIP_WIDTH}
                title={title}
                columnDefinition={COLUMN_DEFINITION_VISITS_OVERTIME}
                data={rows}
            />
        </TooltipWrapper>
    );
};

export default VisitsOvertimeChartTooltip;
